import { render, staticRenderFns } from "./main_navigation.vue?vue&type=template&id=22228fcb&scoped=true&"
import script from "./main_navigation.vue?vue&type=script&lang=js&"
export * from "./main_navigation.vue?vue&type=script&lang=js&"
import style0 from "./main_navigation.vue?vue&type=style&index=0&id=22228fcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22228fcb",
  null
  
)

export default component.exports